import React, { forwardRef } from 'react';
import { useForm } from 'react-hook-form';
import { Node } from 'reactflow';
import { NodeData, Position } from '../../../pages/campaings/flows/types';
import Input from '../../forms/input.component';
import TextArea from '../../forms/text-area.component';

interface CloseNodeFormProps {
  node: Node<NodeData>;
  onSave: (nodeId: string, data: NodeData, position: Position) => void;
}

const CloseNodeForm = forwardRef<HTMLFormElement, CloseNodeFormProps>(({ node, onSave }, ref) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<NodeData>({
    defaultValues: node.data,
    mode: 'onChange'
  });

  const onSubmit = (data: NodeData) => {
    onSave(node.id, data, node.position);
  };

  return (
    <form ref={ref} onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-3">
        <Input
          label="Título del nodo"
          placeholder="Escribe el nombre del nodo"
          requiredIndicator="required"
          {...register('title', { required: 'Este campo es requerido' })}
          errors={errors.title?.message}
        />
      </div>

      <div className="mb-3">
        <TextArea
          label="Mensaje de cierre"
          placeholder="Escribe el mensaje de cierre"
          requiredIndicator="required"
          rows={3}
          {...register('close.message.es', {
            required: 'El mensaje es requerido',
            maxLength: { value: 1024, message: 'Máximo 1024 caracteres' }
          })}
          errors={errors.close?.message}
        />
      </div>

      <div className="mb-3">
        <Input
          label="Categoría de cierre"
          placeholder="Escribe la categoría de cierre"
          requiredIndicator="required"
          {...register('close.category', { required: 'La categoría es requerida' })}
          error={errors.close?.category?.message}
        />
      </div>
    </form>
  );
});

export default CloseNodeForm;
